import axios from 'axios'
export default {

  async listByBussines (businesId, page, startDate, endDate, limit) {
    try {
      const response = await axios.get(
        'cuts/listByBusiness?id=' + businesId +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&limit=' + limit)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPos (terminalId, page, startDate, endDate, limit) {
    try {
      const response = await axios.get(
        'cuts/listByPos?id=' + terminalId +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&limit=' + limit)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

}
